import React from "react";
import { HashRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout } from "../auth/authActions"; // Ação de logout

// Provider para notificações - SISTEMA COMPLETO CORRIGIDO
import { NotificationProvider } from "../notifications";
import Header from "../common/template/header";
import SideBar from "../common/template/sideBar";
import Messages from "../common/msg/messages";
import Routes from "./routes";

const App = ({ user, logout }) => (
  <HashRouter>
    <div className="wrapper">
      <NotificationProvider>
        <Header user={user} logout={logout} />
      </NotificationProvider>
      <SideBar />
      <Routes />
      <Messages />
    </div>
  </HashRouter>
);

const mapStateToProps = (state) => ({ user: state.auth.user });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
